// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__fHUHe","before8":"styles_before8__8VC-E","after6":"styles_after6__2Ti2G"};